module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-database-5.556893a1.svg";